import * as React from 'react';

/**
 * Poses the browser's native `beforeunload` confirmation while `isActive` is true, and removes it
 * otherwise (including on unmount). The declarative router used here exposes no in-app navigation
 * blocker (`useBlocker` requires a data router), so this only guards closing or reloading the browser
 * tab itself — an in-app navigation guard is the caller's own responsibility.
 */
const useBeforeUnloadGuard = (isActive: boolean): void => {
	React.useEffect(() => {
		if (!isActive) {
			return undefined;
		}

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			// Legacy browsers read the confirmation prompt from `returnValue` rather than the
			// return value of the handler.
			event.returnValue = '';
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [isActive]);
};

export default useBeforeUnloadGuard;
